import { InternalPlanPurchaseProviderContext } from './context/InternalPlanPurchaseProviderContext'
import {
  InternalPlanPurchaseProviderContextProps,
  InternalPlanPurchaseProviderContextPropsContext
} from './context/InternalPlanPurchaseProviderContextProps'
import { PlanInterval } from '@dtx-company/true-common/src/types/PlanInterval'
import { PlanPurchaseProviderProps } from './PlanPurchaseProviderProps'
import { usePlanPricingGroup } from '@dtx-company/inter-app/src/hooks/usePlanPricingGroup/usePlanPricingGroup'
import { usePlanPurchaseProviderLoadingState } from './context-hooks/usePlanPurchaseProviderLoadingState'
import { usePlanPurchaseProviderPlanProperties } from './context-hooks/usePlanPurchaseProviderPlanProperties'
import { usePlanPurchaseProviderSelectedPlan } from '@app/plans/src/purchase/PlanPurchaseProvider/context-hooks/usePlanPurchaseProviderSelectedPlan'
import React, { useCallback, useState } from 'react'

/**
 * This provides a context necessary for purchasing new plans.
 *
 * A "purchase" includes upgrades and downgrades (once we support them again).
 * It does not include changing addons, changing interval, or changing payment method.
 */
export function PlanPurchaseProvider(props: PlanPurchaseProviderProps): JSX.Element {
  const { children } = props
  const pricingGroup = usePlanPricingGroup()
  const [context, setContext] = useState<InternalPlanPurchaseProviderContextPropsContext>({
    isLoaded: false,
    loadingErrorType: undefined,
    planInterval: PlanInterval.YEARLY,
    planType: props.planType,
    pricingGroup,
    plans: undefined,
    selectedPlan: undefined
  })

  const updateContext: InternalPlanPurchaseProviderContextProps['updateContext'] = useCallback(
    partialContext => {
      setContext(actualContext => ({ ...actualContext, ...partialContext }))
    },
    []
  )

  usePlanPurchaseProviderLoadingState(props, context, updateContext)
  usePlanPurchaseProviderPlanProperties(props, context, updateContext)
  usePlanPurchaseProviderSelectedPlan(props, context, updateContext)

  return (
    <InternalPlanPurchaseProviderContext.Provider value={{ context, updateContext }}>
      {children}
    </InternalPlanPurchaseProviderContext.Provider>
  )
}
